

export default  () =>{
    return <>Registration closed.</>
}